/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tyc_Law_TitleInputs */

const es_tyc_law_title = /** @type {(inputs: Tyc_Law_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10. Ley Aplicable y Jurisdiccion`)
};

const en_tyc_law_title = /** @type {(inputs: Tyc_Law_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10. Governing Law and Jurisdiction`)
};

/**
* | output |
* | --- |
* | "10. Governing Law and Jurisdiction" |
*
* @param {Tyc_Law_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tyc_law_title = /** @type {((inputs?: Tyc_Law_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tyc_Law_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tyc_law_title(inputs)
	return en_tyc_law_title(inputs)
});
export { tyc_law_title as "tyc.law.title" }